import Lang from "../lang";

export default { // methods
    getLayoutDirection () {
        if (Lang.getLocale() == 'en'){
            return 'ltr';
        }
        return 'rtl';
    }
}
